
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Nashikcab() {



    const cardData =
    {
        keyword: ' Pune to Nashik Cab',
        heading: 'S9 Travels:  Pune to Nashik Cab',
        headingDescription: 'S9 Travels provides affordable and reliable Pune to Nashik cab services, ideal for pilgrimage tours, weekend getaways, or corporate travel. Covering a distance of approximately 210 km, the journey takes about 4 to 5 hours through a scenic and well-connected highway route.',

        top: 'Top Places to Visit in Nashik with S9 Travels',

"topPlaces": [
    {
      "title": "Sula Vineyards",
      "description": "Sula Vineyards is India's most famous winery, offering vineyard tours, wine tastings, and a beautiful landscape. It is a must-visit for wine enthusiasts."
    },
    {
      "title": "Trimbakeshwar Temple",
      "description": "One of the twelve Jyotirlingas of Lord Shiva, Trimbakeshwar Temple is a highly revered Hindu pilgrimage site known for its spiritual significance and ancient architecture."
    },
    {
      "title": "Panchavati",
      "description": "Panchavati is a sacred area in Nashik with religious sites like Sita Gufa, Kalaram Temple, and Ramkund, associated with the Ramayana."
    },
    {
      "title": "Pandav Leni Caves",
      "description": "These ancient rock-cut caves date back to the 1st century BCE and feature Buddhist sculptures and inscriptions. They offer a historical and scenic experience."
    },
    {
      "title": "Anjneri Hill",
      "description": "Believed to be the birthplace of Lord Hanuman, Anjneri Hill is a popular trekking spot with breathtaking views and spiritual significance."
    },
    {
      "title": "Someshwar Waterfall",
      "description": "Located near the Someshwar Temple, this picturesque waterfall is a serene spot, especially during the monsoon season."
    },
    {
      "title": "Dudhsagar Falls (Nashik)",
      "description": "Not to be confused with Goa’s Dudhsagar Falls, this smaller yet scenic waterfall is a great picnic spot near Nashik."
    },
    {
      "title": "Harihar Fort",
      "description": "A thrilling trekking destination, Harihar Fort features a steep, rock-cut staircase leading to mesmerizing views from the top."
    },
    {
      "title": "Saptashrungi Devi Temple",
      "description": "Situated on a hill, this revered temple dedicated to Goddess Saptashrungi offers breathtaking views and is an important pilgrimage site."
    },
    {
      "title": "Coin Museum",
      "description": "India’s only museum dedicated to coins, showcasing the history of Indian currency with rare coin collections and exhibits."
    }
],

"services": [
  {
    "name": "Pune to Nashik Cab Service",
    "description": "Book a trusted Pune to Nashik cab with S9 Travels. Whether you’re heading for a pilgrimage, business meeting, or family trip, our clean AC cars and professional drivers ensure a smooth and safe journey across 210 km."
  },
  {
    "name": "Book Pune to Nashik Taxi Online",
    "description": "Easily book your Pune to Nashik taxi online with S9 Travels. Select from sedans, SUVs, or Innova cabs based on your group size and enjoy door-to-door pickup with real-time tracking and 24/7 support."
  },
  {
    "name": "Affordable Pune to Nashik Cab Fare",
    "description": "Travel affordably from Pune to Nashik without compromising comfort. Our cab fares are competitive, with no hidden charges and high-quality service included in every ride."
  },
  {
    "name": "Private Cab from Pune to Nashik",
    "description": "Choose a private cab for a comfortable and quiet Pune to Nashik ride. Ideal for solo travelers, couples, or families seeking a personalized and uninterrupted journey."
  },
  {
    "name": "One-Way & Round Trip Taxi Pune to Nashik",
    "description": "Get flexible booking options with one-way or round-trip cabs from Pune to Nashik. Perfect for same-day returns or extended stays—tailored to your itinerary."
  },
  {
    "name": "Luxury Cab Pune to Nashik",
    "description": "Upgrade your travel with our luxury Pune to Nashik taxi service. Travel in style with premium interiors, bottled water, AC, and expert chauffeurs—ideal for executives or special occasions."
  },
  {
    "name": "Comfortable Taxi Ride to Nashik",
    "description": "Experience a peaceful and comfortable taxi ride from Pune to Nashik. Our vehicles are regularly serviced for cleanliness, safety, and a smooth suspension ideal for long-distance travel."
  },
  {
    "name": "Pune to Nashik Sightseeing Taxi",
    "description": "Planning to visit Nashik’s top attractions like Trimbakeshwar, Sula Vineyards, or Panchavati? Book a sightseeing cab from Pune with a local driver who knows the best spots and timings."
  },
  {
    "name": "Group Travel Cab Pune to Nashik",
    "description": "Travelling with friends or colleagues? Our group-friendly cabs, including 7-seaters like Innova and Ertiga, offer ample space for luggage and ensure everyone enjoys the ride together comfortably."
  }
],
  "tableData": [
    ["Pune to Nashik Cab Service", "Book Pune to Nashik Taxi"],
    ["Affordable Pune to Nashik Cab", "Private Taxi for Nashik from Pune"],
    ["Pune to Nashik One-Way or Round Trip", "Luxury Cab from Pune to Nashik"],
    ["Comfortable Taxi Ride for Nashik", "Nashik Sightseeing by Taxi from Pune"],
    ["Group Travel to Nashik from Pune", "Pune to Nashik One-Way or Round Trip"]
  ],



"whychoose": [
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "At S9 Travels, we understand the importance of timely travel. Whether you're heading from Pune to Nashik or vice versa, we ensure reliable pickups and smooth rides. Our drivers are punctual, ensuring you reach your destination on time, every time."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "Our Toyota Innova is the perfect vehicle for your Pune to Nashik journey. With comfortable seating, air conditioning, and ample space for luggage, you’ll enjoy a relaxing and stress-free ride. Whether you’re traveling solo or with family and friends, our vehicles provide all the comfort you need."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are experienced, professional, and well-versed in the best routes from Pune to Nashik. They are courteous, knowledgeable, and committed to providing a smooth, safe, and enjoyable journey. You can relax and trust our drivers for a hassle-free trip."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive and transparent pricing for your Pune to Nashik cab ride. You’ll receive a clear breakdown of all costs before confirming your booking, with no hidden charges, allowing you to plan your travel comfortably."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Journey",
    "WhyChoosedescription": "Safety is our priority. Our Toyota Innova vehicles are equipped with modern safety features like airbags, seat belts, and GPS tracking, ensuring a secure and comfortable journey from Pune to Nashik."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "S9 Travels is available 24/7 for your Pune to Nashik journey. Whether you need an early morning ride or a late-night drive, we will ensure that your ride is ready when you need it. Our customer service team is also available around the clock to assist you."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking your Pune to Nashik cab is easy with S9 Travels. You can book online through our website or mobile app, or you can contact our customer service team for personalized assistance in booking your ride."
  },
  {
    "WhyChooseheading": "Customized Travel Packages",
    "WhyChoosedescription": "We offer customized travel packages for your Pune to Nashik trip. Whether you want to make additional stops or have specific preferences, we tailor the trip to meet your needs, ensuring a pleasant and personalized experience."
  }
]







    }



    const faqData = [
        [
          {
            question: 'How can I book a cab from Pune to Nashik with S9 Travels?',
            answer: 'Booking a cab for your Pune to Nashik trip is easy! You can book online via our website or mobile app, or contact our customer service team for assistance with your booking.'
          },
          {
            question: 'What types of cabs are available for Pune to Nashik travel?',
            answer: 'We offer a variety of vehicles, including the spacious Toyota Innova, perfect for families, groups, or travelers with a lot of luggage. Choose the vehicle that suits your needs for a comfortable journey to Nashik.'
          },
          {
            question: 'Are the drivers experienced for the Pune to Nashik route?',
            answer: 'Yes, our drivers are highly experienced and familiar with the best routes from Pune to Nashik. They ensure a smooth, safe, and timely journey for all passengers.'
          },
          {
            question: 'What payment options are available for booking a cab from Pune to Nashik?',
            answer: 'We offer flexible payment options, including cash, credit/debit cards, and secure online payments via our app, making it easy and convenient to pay for your ride.'
          },
          {
            question: 'Can I book a round trip for Pune to Nashik?',
            answer: 'Yes, we offer round-trip bookings. Simply provide us with your return details, and we’ll arrange a comfortable and timely ride back from Nashik to Pune.'
          },
          {
            question: 'Are there any extra charges for detours or waiting time during the trip?',
            answer: 'Any extra charges for detours or waiting time will be clearly communicated to you upfront, ensuring transparency in pricing.'
          },
          {
            question: 'Can I make additional stops on the way from Pune to Nashik?',
            answer: 'Yes, you can request additional stops during your trip. Please inform us when booking, and we’ll accommodate your requests for stops along the way.'
          },
          {
            question: 'What is the luggage allowance for a cab on the Pune to Nashik trip?',
            answer: 'The Toyota Innova offers ample space for standard luggage. If you have more luggage or special requirements, please let us know during booking, and we’ll make necessary arrangements.'
          },
          {
            question: 'Does S9 Travels provide corporate travel services for Pune to Nashik?',
            answer: 'Yes, we offer corporate travel services for business trips from Pune to Nashik. We ensure a professional, comfortable, and timely service for business travelers.'
          },
          {
            question: 'Why should I choose S9 Travels for my Pune to Nashik cab booking?',
            answer: 'S9 Travels offers a reliable, safe, and comfortable ride with professional drivers, well-maintained vehicles, and excellent customer service, ensuring a smooth and enjoyable journey from Pune to Nashik.'
          }
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Vikram Patil',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I booked a cab from Pune to Nashik with S9 Travels, and it was a wonderful experience. The driver was on time, the car was clean and comfortable, and the journey was smooth. Highly recommend their services for anyone traveling to Nashik from Pune!”'
        },
        {
          name: 'Mrs. Anjali Deshmukh',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I traveled from Pune to Nashik with my family using S9 Travels, and the experience was excellent. The vehicle was spacious, well-maintained, and the driver was very professional. I’ll definitely choose S9 Travels for future trips!”'
        }
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
      
    // const productSchema = {
    //     "@context": "https://schema.org",
    //     "@type": "Product",
    //     "name": "Pune to Nashik Cab",
    //     "image": "https://www.s9travels.com/assets/images/pune-to-nashik-cab.jpg",
    //     "description": "Book a comfortable and affordable Pune to Nashik cab service with S9 Travels. Enjoy a smooth and scenic journey with professional drivers. Whether you're traveling for leisure or business, choose from one-way or round-trip options, and travel in well-maintained vehicles for a hassle-free experience.",
    //     "brand": {
    //       "@type": "Brand",
    //       "name": "S9 Travels"
    //     },
    //     "aggregateRating": {
    //       "@type": "AggregateRating",
    //       "bestRating": "5",
    //       "worstRating": "1",
    //       "ratingValue": "4.8",
    //       "ratingCount": "2765"
    //     },
    //     "offers": {
    //       "@type": "Offer",
    //       "priceCurrency": "INR",
    //       "price": "3499",
    //       "availability": "https://schema.org/InStock",
    //       "url": "https://www.s9travels.com/pune-to-nashik-cab"
    //     }
    //   };
      // by this showing on 4:1
      

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Nashik Cab Service – S9 Travels",
  "image": "https://www.s9travels.com/assets/images/pune-to-nashik-cab.jpg",
  "description": "Hire Pune to Nashik cab with S9 Travels starting at ₹3499. Choose Hatchback, Sedan, SUV & Innova Crysta for one-way or round trips. Comfortable and safe travel to Nashik city, Trimbakeshwar Temple, and Sula Vineyards with professional drivers, clean AC cars, on-time pickup, and 24/7 booking support.",
  "brand": {
    "@type": "Brand",
    "name": "S9 Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "5412"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3499",
    "availability": "https://schema.org/InStock",
    "url": "https://www.s9travels.com/pune-to-nashik-cab"
  }
};

      
      
      


    return (
        <div>


<Helmet>
  <title>Pune to Nashik Cab from ₹3499 | Trimbakeshwar & Round Trip Taxi –  S9Travels</title>

  <meta 
    name="description" 
    content="Book Pune to Nashik cab online with S9 Travels from ₹3499. One-way & round-trip AC taxis, Innova, SUVs, and Sedans available. Travel to Nashik, Trimbakeshwar Temple, and Sula Vineyards with professional drivers, safe rides, 24/7 support, and instant confirmation."
  />

  <meta 
    name="keywords" 
    content="Pune to Nashik Cab, Pune to Nashik Taxi, One Way Cab Pune Nashik, Round Trip Pune Nashik Taxi, Pune to Nashik Innova Crysta, SUV Taxi Pune to Nashik, Trimbakeshwar Darshan Cab Pune, Pune to Sula Vineyards Taxi, Affordable Cab Pune Nashik, Luxury Taxi Pune to Nashik"
  />

  <link rel="canonical" href="https://s9travels.com/pune-to-nashik-cab" />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


              {/* <Helmet>
  <title>Pune to Nashik Cab Booking | S9 Travels</title>

  <meta 
    name="description" 
    content="Book Pune to Nashik cab service with S9 Travels. One-way and round-trip AC cabs available at affordable fares. Ideal for temple visits, business travel, or weekend getaways with 24/7 support and expert drivers." 
  />

  <meta 
    name="keywords" 
    content="Pune to Nashik Cab, Pune to Nashik Taxi Booking, One Way Cab Pune Nashik, Round Trip Pune Nashik Cab, Pune to Nashik Car Hire, AC Taxi Pune to Nashik, S9 Travels Pune Nashik, Nashik Darshan Cab from Pune, Pune to Trimbakeshwar Cab" 
  />

  <link rel="canonical" href="https://s9travels.com/pune-to-nashik-cab" />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet> */}


         

      
      
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/97.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Nashikcab;